import { routerReducer as router } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import { combineReducers, Reducer } from 'redux';
import { reducer as header } from '../scenes/Shell/scenes/Header/reducer';
import { reducer as content } from '../services/content/reducer';
import { reducer as branding } from '../services/branding/reducer';
import { reducer as quote } from '../services/quote/reducer';
import { reducer as auth } from '../services/auth/reducer';
import { IStore } from './IStore';

const rootReducer: Reducer<IStore> = combineReducers<IStore>({
  auth,
  router,
  form,
  branding,
  header,
  content,
  quote,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/redux/reducers.ts